function titleize(value) {
  return String(value || "")
    .replace(/[._:]+/g, " ")
    .replace(/\s+/g, " ")
    .trim()
    .split(" ")
    .filter(Boolean)
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
    .join(" ");
}

export function getActivityCategoryText(log) {
  return log?.category_label || titleize(log?.category) || "General";
}

export function getActivityActionText(log) {
  return log?.action_label || titleize(log?.action_type) || "Activity";
}
